import { connect } from 'react-redux';
import AccountDetailForm from '../components/AccountDetailForm';
import { getMemberType } from '../selectors/converterSelector';
import {
    requestInfo,
    submitAccountHolderInformation,
} from '../actions/userActions';
import {
    saveBusinessAddress,
    createAddress,
    updateAddress,
    deleteAddress,
    makeDefaultBillingAddress,
    saveDispatchLocation,
    deleteDispatchLocation,
    makeDefaultDispatchLocation,
} from '../actions/user/address';
import {
    createPostman,
    deletePostman,
    editPostman,
} from '../actions/user/postmen';

import {
    requestCartRule,
    createCartRule,
    deleteCartRule,
    editCartRule,
} from '../actions/user/cartRule';

import {
    createCreditCard,
    deleteCreditCard,
    makeDefaultCreditCard,
} from '../actions/user/creditCards';
import {
    createPICNumber,
    deletePICNumber,
    makeDefaultPICNumber,
} from '../actions/user/picNumbers';
import { createReferralCoupon } from '../actions/user/referralCoupon';
import { deleteWholesalerReseller } from '../actions/user/wholesalerReseller';
import { getUserFullInfo } from '../selectors/userSelector';

const mapStateToProps = function (store) {
    return {
        globalConfig: store.globalConfig.data,
        isLoading: store.user.isLoading,
        userReAuth: store.user.isReAuth,
        initialized: store.user.initialized,
        memberType: getMemberType(store),
        userInfo: getUserFullInfo(store.user.info, store.address.list), // IMPORTANT: This will always display the currently logged in user
    };
};

const mapDispatchToProps = function (dispatch, ownProps) {
    return {
        requestInfo: () => dispatch(requestInfo()),
        submitAccountHolderInformation: (formData, callback) =>
            dispatch(submitAccountHolderInformation(formData, callback)),

        saveBusinessAddress: (formData, callback) =>
            dispatch(saveBusinessAddress(formData, callback)),

        saveDispatchLocation: (formData, callback, id) =>
            dispatch(saveDispatchLocation(formData, callback, id)),
        deleteDispatchLocation: (id, callback) => dispatch(deleteDispatchLocation(id, callback)),
        makeDefaultDispatchLocation: (id, callback) =>
            dispatch(makeDefaultDispatchLocation(id, callback)),

        createAddress: (formData, callback) =>
            dispatch(createAddress(formData, callback)),
        updateAddress: (formData, callback) =>
            dispatch(updateAddress(formData, callback)),
        deleteAddress: (id, callback) => dispatch(deleteAddress(id, callback)),

        makeDefaultBillingAddress: (id, callback) =>
            dispatch(makeDefaultBillingAddress(id, callback)),

        createPostman: (formData, callback) =>
            dispatch(createPostman(formData, callback)),
        editPostman: (id, callback) => dispatch(editPostman(id, callback)),
        deletePostman: (id, callback) => dispatch(deletePostman(id, callback)),

        requestCartRule: () => dispatch(requestCartRule()),
        createCartRule: (formData, callback) =>
            dispatch(createCartRule(formData, callback)),
        editCartRule: (formData, callback) => dispatch(editCartRule(formData, callback)),
        deleteCartRule: (id, callback) =>
            dispatch(deleteCartRule(id, callback)),

        createCreditCard: (formData, callback) =>
            dispatch(createCreditCard(formData, callback)),
        deleteCreditCard: (id, callback) =>
            dispatch(deleteCreditCard(id, callback)),
        makeDefaultCreditCard: (id, callback) =>
            dispatch(makeDefaultCreditCard(id, callback)),

        createPICNumber: (formData, callback) =>
            dispatch(createPICNumber(formData, callback)),
        deletePICNumber: (id, callback) =>
            dispatch(deletePICNumber(id, callback)),
        makeDefaultPICNumber: (id, callback) =>
            dispatch(makeDefaultPICNumber(id, callback)),

        deleteWholesalerReseller: (id, callback) =>
            dispatch(deleteWholesalerReseller(id, callback)),

        createReferralCoupon: (formData, callback) =>
            dispatch(createReferralCoupon(formData, callback)),
    };
};
const ConnectedAccountDetailForm = connect(
    mapStateToProps,
    mapDispatchToProps
)(AccountDetailForm);

export default ConnectedAccountDetailForm;
